import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { addProps } from 'utils/recompose';
import combineSelectors from 'utils/combineSelectors';
import { theme } from 'reducers/dashboard/selectors';
import { modelWorkingStateDenormalized } from 'reducers/models/selectors';
import { updateModelWorkingState } from 'reducers/models/actions';
import changeTemplateStatus from 'utils/changeTemplateStatus';

export const removeFromCart = ({
  modelWorkingStateDenormalized,
  templateId,
  updateModelWorkingState,
}) => () => {
  const newWorkingState = changeTemplateStatus(
    modelWorkingStateDenormalized,
    templateId,
    'inReview',
  );
  updateModelWorkingState(newWorkingState);
};

const mapStateToProps = combineSelectors({
  modelWorkingStateDenormalized,
  theme,
});

export const buttonBackground = ({ theme }) => ({
  backgroundColor: theme.button.removeFromCart,
});

export default compose(
  connect(
    mapStateToProps,
    {
      updateModelWorkingState,
    },
  ),
  withHandlers({ removeFromCart }),
  addProps({ buttonBackground }),
);
